import { request } from '@blade/common';
// 获取考勤列表
export const getAttendanceListApi = (data) => request.post('/api/access-management/api/v1/attendance/record/search', data);
// 导出考勤记录
export const exportAttendanceRecordApi = (data) => request.post('/api/access-management/api/v1/attendance/record/export', data);
// 考勤记录详情
export const getAttendanceDetailApi = (data) => request.post('/api/access-management/api/v1/attendance/record/detail', data);
